
import Vue, { PropType } from 'vue';
import Badge from '@/common/badge/Badge.vue';

export default Vue.extend({
    components: {
        Badge
    },

    props: {
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        }
    },

});
